import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  propTypes,
  LINE_ITEM_CUSTOMER_COMMISSION,
  LINE_ITEM_CUSTOMER_COMMISSION_VAT,
} from '../../util/types';

import css from './BookingBreakdown.css';

const { Money } = sdkTypes;
const FEE_CODES = [LINE_ITEM_CUSTOMER_COMMISSION, LINE_ITEM_CUSTOMER_COMMISSION_VAT];

// The refunded fee and its VAT as one row (customer service fee spec §5).
const LineItemCustomerCommissionRefundMaybe = props => {
  const { transaction, isCustomer, intl } = props;

  const refunds = transaction.attributes.lineItems.filter(
    item => FEE_CODES.includes(item.code) && item.reversal
  );
  if (!isCustomer || refunds.length === 0) return null;
  const refund = new Money(
    refunds.reduce((sum, item) => sum + item.lineTotal.amount, 0),
    refunds[0].lineTotal.currency
  );

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="BookingBreakdown.refundCustomerFee" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, refund)}</span>
    </div>
  );
};

LineItemCustomerCommissionRefundMaybe.propTypes = {
  transaction: propTypes.transaction.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemCustomerCommissionRefundMaybe;
